<template>
    <div v-if="activeLocationsCount == 0">
        You must have an active shared location to be able to see other locations. Please add/enable at least one location
    </div>
    <div v-if="activeLocationsCount > 0">

        <div class="input-group mb-2 mt-2">
            <input type="text" class="form-control" placeholder="Search Address" v-model="address"/>
            <button class="btn btn-info" @click="lookupAddress()">Search</button>
        </div>

        <div class="mb-2" v-if="coordinates == null">
            Enter a location above and press 'Search' to find solar locations near that location
        </div>

        <div class="input-group mb-2" v-if="coordinates != null">
            <select class="form-control me-1" v-model="mostRecentDays" @change="updateAllLocationsChartData()">
                <option value="0">All</option>
                <option value="30">Recent 30 Days</option>
                <option value="60">Recent 60 Days</option>
                <option value="90">Recent 90 Days</option>
                <option value="120">Recent 120 Days</option>
                <option value="180">Recent 180 Days</option>
                <option value="365">Recent 365 Days</option>
            </select>
            <select class="form-control" v-model="distance" @change="getLocations()">
                <option value="1">Within 1 Mile</option>
                <option value="5">Within 5 Miles</option>
                <option value="10">Within 10 Miles</option>
                <option value="20">Within 20 Miles</option>
                <option value="50">Within 50 Miles</option>
                <option value="100">Within 100 Miles</option>
                <option value="250">Within 250 Miles</option>                
                <option value="1000">Within 1000 Miles</option>
                <option value="5000">Within 5000 Miles</option>
                <option value="10000">Within 10000 Miles</option>
            </select>
            <button class="btn btn-info" @click="getLocations()"><font-awesome-icon :icon="['fas', 'arrows-rotate']"/></button>
        </div>
      
      <div class="row">
        <div class="col-md-6 mb-3">
            <SolarLocationsMerged v-if="solarLocations.length > 0 && readyCount >= solarLocations.length" :locations="solarLocations" />  
        </div>
        <div class="col-md-6 mb-3">
            <SingleDaySolarData v-if="solarLocations.length > 0 && readyCount >= solarLocations.length" :locations="solarLocations" :chartOptions="chartOptions" />  
        </div>
            <div class="col-md-6 mb-3" v-for="location in solarLocations" :key="location.id">
                <SolarLocation :location="location" :chartOptions="chartOptions" @refreshLocation="displayLocation" />
            </div>
      </div>
    </div>
  </template>
  
  <script>
  import pb from '../api';
  import SolarLocation from './SolarLocation.vue'
  import SolarLocationsMerged from './SolarLocationsMerged.vue';
  import SingleDaySolarData from './SingleDaySolarData.vue'
  import { store } from '../store';
  import { useToast } from 'vue-toastification';

  export default {
    name: 'SolarLocations',
    components: {
        SolarLocation,
        SolarLocationsMerged,
        SingleDaySolarData
    },
    data() {
      return {
        solarLocations: [],
        mostRecentDays: 30,
        chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    max: 100000,
                    title: {
                        text: "Wh",
                        display: true
                    }
                }
            }
        },
        readyCount: 0,
        distance: "10",
//        latitude: 0.0,
//        longitude: 0.0,
        address: "",
        coordinates: null,
        activeLocationsCount: 0
      };
    },
    async mounted() {
        this.getStoredSettings();
        this.findMyLocations();
        //this.getLocationThenLocations();
    },
    methods: {
        async findMyLocations() {
            let owner = pb.authStore.record.id;
            const solarLocations = await pb.collection('solarLocations').getList(1, 1, {filter: `owner.id='${owner}' && disabled=0`});  
            //console.log("My locations: " + JSON.stringify(solarLocations));
            this.activeLocationsCount = solarLocations.totalItems;
            if(this.activeLocationsCount > 0) {
                this.getLocationThenLocations();
            }
        },
        async lookupAddress() {
            let toast = useToast();
            try {
                store.isLoading = true;
                let addressLocation = await pb.send("/lookupAddress?address=" + this.address);
                if(addressLocation.isError) {
                    toast.error(addressLocation.error);
                }
                else {
                    this.coordinates = {
                        latitude: addressLocation.location.lat,
                        longitude: addressLocation.location.lon,
                    };
                    this.getLocationThenLocations();
                }
            }
            catch(e) {
                toast.error(e);
            }
            finally {
                store.isLoading = false;
            }
        },
        async addLocation(solarId) {
            await pb.send("/solarEndpoint?solarId=" + solarId, {method: "POST"});
            await this.getLocations();
        },
        async getLocationThenLocations() {

            if(this.coordinates != null) {
                this.getLocations();
            }
            else {
                console.log("coordinates are null");
            }
        },
        async getLocations() {
            this.persistSettings();
           let toast = useToast();
           this.readyCount = 0;
            try {
                let url = `/nearbyLocations?latitude=${this.coordinates.latitude}&longitude=${this.coordinates.longitude}&distance=${this.distance}`;
                const solarLocations = await pb.send(url);
                //let items = solarLocations.items;
                this.solarLocations = solarLocations;
                for(let i = 0; i < this.solarLocations.length; i++) {
                    this.displayLocation(this.solarLocations[i]);
                    //this.displayLocation(items[i]);
                }

            }
            catch(e) {
                console.log("Error: " + e);
                toast.error("Error: " + e);
            }
            finally {
                store.isLoading = false;
            }
        },
        async displayLocation(location) {
            location.loading = true;
            try {

                let friendlyName = location.friendlyName;
                let address = location.address;
                let fullDisplayName = address;
                if(friendlyName == null || friendlyName == '') {
                    friendlyName = address;
                    location.friendlyName = address;
                }
                else {
                    fullDisplayName = friendlyName + " - " + address;
                }
                location.fullDisplayName = fullDisplayName;
                //console.log("Location color is: " + location.color);
                if(!location.color) {
                    location.color = this.randomColorGenerator();
                }

                let solarData = await pb.send("/getSolarData?solarId=" + location.solarId);
                //console.log("data is: " + solarData);
                location.systemId = solarData.system_id;
                location.dailyValues = solarData.dailyValues; // for safe keeping
                this.updateLocationChartData(location);
            }
            catch(e) {
                location.error = e;
            }
            finally {
                location.loading = false;
                //console.log("loading is done");
                this.readyCount++;
                //console.log("ready count is: " + this.readyCount);
            }
        },
        updateLocationChartData(location) {
            if(!location.dailyValues) {
                return;
                //console.log("location does not have dailyValues, weird");
            }
            let data = [];
            let chartData = {
                labels: [],
                datasets: [ {
                    label: "Production",
                    //backgroundColor: '#f87979',
                    backgroundColor: location.color,
                    data: data
                }]
            };

            let end = 0;
            if(this.mostRecentDays > 0 && location.dailyValues.length > this.mostRecentDays) {
                end = location.dailyValues.length - this.mostRecentDays;
            }

            for(let i = location.dailyValues.length - 1; i >= end; i--) {
                let dv = location.dailyValues[i];
                chartData.labels.unshift(dv.prettyDate);
                data.unshift(dv.production)
            }

            location.chartData = chartData;
        },
        updateAllLocationsChartData() {
            for(let i = 0; i < this.solarLocations.length; i++) {
                this.updateLocationChartData(this.solarLocations[i]);
            }
            this.persistSettings();
        },
        randomColorGenerator()  { 
            return '#' + (Math.random().toString(16) + '0000000').slice(2, 8); 
        },
        getStoredSettings() {
            let storedSettings = localStorage.getItem("solarSettings");
            if(storedSettings) {
                let settings = JSON.parse(storedSettings);
                this.mostRecentDays = settings.mostRecentDays;
                this.distance = settings.distance;
                if(settings.latitude) {
                    this.coordinates = {
                        latitude: settings.latitude,
                        longitude: settings.longitude
                    }            
                    this.address = settings.address;
                    //console.log("coordinates are set");
                }
            }
        },
        persistSettings() {
            let storedSettings = {
                mostRecentDays: this.mostRecentDays,
                distance: this.distance,
                address: this.address
            }
            if(this.coordinates) {
                storedSettings.latitude = this.coordinates.latitude;
                storedSettings.longitude = this.coordinates.longitude;
            }
            localStorage.setItem("solarSettings", JSON.stringify(storedSettings));
        }
    }
  };
  </script>
  
  <style scoped>  
  .card {
    /*
    cursor: pointer;
    */
  }
  </style>